import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { MsalProvider } from '@azure/msal-react';
import { QueryClient } from '@tanstack/react-query';
import { Persister, PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental';
import msalInstance from 'utils/msalInstance';
import Router from 'Router';
import { ToastContainer } from 'react-toastify';

import 'react-day-picker/style.css';
import './index.css';

const queryClient = new QueryClient();

broadcastQueryClient({
  queryClient,
  broadcastChannel: 'oresundsbron-tollling-admin',
});

const persister: Persister = createSyncStoragePersister({
  storage: window.sessionStorage,
});

void (async () => {
  await msalInstance.initialize();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
        <MsalProvider instance={msalInstance}>
          <Router />
          <ToastContainer />
        </MsalProvider>
      </PersistQueryClientProvider>
    </StrictMode>
  );
})();
